import { SvgIcon } from '@mui/material';
import './ccf-custom-fields-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfCustomFieldsIconProps  {}

/**
 *
 * @param props - CcfCustomFieldsIcon
 * @example <CcfCustomFieldsIcon />
 * @returns
 */
export function CcfCustomFieldsIcon(props: CcfCustomFieldsIconProps) {
  return (
    <SvgIcon
      // width="20"
      // height="16"
      // viewBox="0 0 20 16"
      // fill="none"
      {...props}
    >
      <path
        d="M4.21067 11.2712H0.992C0.729021 11.2712 0.476803 11.1674 0.290786 10.9827C0.104769 10.7979 0.000176733 10.5472 0 10.2858L0 5.71314C0.000353312 5.45184 0.105023 5.20136 0.291021 5.01672C0.477019 4.83207 0.729136 4.72836 0.992 4.72836H4.21067V6.69924H1.98333V9.30036H4.21067V11.2712ZM19.0107 4.72836H8.86067V6.69924H18.0167V9.30036H8.86067V11.2712H19.008C19.271 11.2712 19.5232 11.1674 19.7092 10.9827C19.8952 10.7979 19.9998 10.5472 20 10.2858V5.71314C19.9996 5.45184 19.895 5.20136 19.709 5.01672C19.523 4.83207 19.2709 4.72836 19.008 4.72836H19.0107ZM9.084 14.0288H7.52733V1.97151H9.084C9.34256 1.96485 9.58827 1.85806 9.76877 1.67392C9.94927 1.48978 10.0503 1.24284 10.0503 0.985738C10.0503 0.728633 9.94927 0.481695 9.76877 0.297554C9.58827 0.113412 9.34256 0.00662973 9.084 -3.48371e-05H3.98733C3.85494 -0.00344738 3.7232 0.0195265 3.59989 0.0675319C3.47657 0.115537 3.36417 0.187602 3.26932 0.279477C3.17447 0.371353 3.09908 0.481177 3.04761 0.602476C2.99614 0.723774 2.96962 0.854089 2.96962 0.985738C2.96962 1.11739 2.99614 1.2477 3.04761 1.369C3.09908 1.4903 3.17447 1.60012 3.26932 1.692C3.36417 1.78387 3.47657 1.85594 3.59989 1.90394C3.7232 1.95195 3.85494 1.97492 3.98733 1.97151H5.544V14.0288H3.98733C3.72442 14.0288 3.47227 14.1326 3.28635 14.3174C3.10044 14.5022 2.996 14.7528 2.996 15.0142C2.996 15.2755 3.10044 15.5262 3.28635 15.711C3.47227 15.8958 3.72442 15.9996 3.98733 15.9996H9.084C9.34692 15.9996 9.59907 15.8958 9.78498 15.711C9.97089 15.5262 10.0753 15.2755 10.0753 15.0142C10.0753 14.7528 9.97089 14.5022 9.78498 14.3174C9.59907 14.1326 9.34692 14.0288 9.084 14.0288Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfCustomFieldsIcon;
